
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/cases/retail/page/[id]",
      function () {
        return require("private-next-pages/cases/retail/page/[id].tsx");
      }
    ]);
  